<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">API</div>
        <div>
          <bread-crumb :bread-crumbs="['Api']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text>
        <v-form ref="logs">
          <v-row class="mt-1">
            <v-col cols="12" md="2" lg="3" xs="12">
              <v-autocomplete
                v-model="service"
                placeholder="Service"
                dense
                outlined
                :items="Servicesarray"
                item-text="name"
                item-value="id"
                :rules="ServiceRules"
                @change="getEndpointValues()"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="2" lg="2" xs="12" v-if="service">
              <v-autocomplete
                v-model="end_point"
                placeholder="End Point"
                dense
                outlined
                :items="Endpointarray"
                item-text="name"
                item-value="id"
                :rules="endpointRules"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="2" lg="2" xs="12">
              <v-text-field
                v-model="record_id"
                placeholder="Record Id"
                dense
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" lg="2" xs="12">
              <v-text-field
                type="date"
                label="From date"
                v-model="to_date"
                :items="apiLogs"
                :rules="[validateToDate]"
                :max="maxDate"
                dense
                outlined
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" lg="2" xs="12">
              <v-text-field
                type="date"
                label="To date"
                v-model="from_date"
                :items="apiLogs"
                :rules="[validateToDate]"
                :max="maxDate"
                dense
                clearable
                outlined
              ></v-text-field>
            </v-col>

            <div class="d-flex">
              <v-btn
                depressed
                class="text-capitalize"
                color="primary"
                small
                @click="getApilogdata()"
                >Get Results</v-btn
              >
            </div>
          </v-row>
        </v-form>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="12" md="4" lg="4" xs="12"
            ><v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to search the table data."
              hide-details
              single-line
              class="me-4"
              dense
              clearable
            ></v-text-field
          ></v-col>
        </v-row>
        <v-data-table
          fixed-header
          height="55vh"
          class="mt-6"
          :headers="headers"
          :items="apiLogs"
          :items-per-page="10"
          dense
          loading-text="Please select the criteria to view records."
          no-data-text="Please select the criteria to view records."
        >
          <template v-slot:item.token_payload="{ item }">
            <v-btn
              title="Click to Download Log"
              @click="downloadTxtFile(item)"
              color="primary"
              small
              icon
            >
              <v-icon>mdi-download </v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
      <OverlayPageVue :showOverlay="loaderOverlay" />
    </v-card>
  </section>
</template>

<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import commonService from "@/services/CommonService/commonService.js";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import { LogsManage } from "@/utils/validationCopy.js";
import downloadFile from "@/utils/ExportTxt/downloadfile.js";
export default {
  name: "Api",
  components: {
    BreadCrumb,
    OverlayPageVue,
  },
  data: () => ({
    ...LogsManage,
    downloadFile,
    headers: [
      { text: "ID", value: "_id", width: "100" },
      {
        text: "Api Route Uri",
        value: "api_route_uri",
        align: "start",
        width: "200",
      },
      {
        text: "Api Route Method",
        value: "api_route_method",
        align: "start",
        width: "50",
      },
      {
        text: "Token Payload",
        value: "token_payload",
        align: "start",
        width: "250",
      },
      {
        text: "Function Involved ",
        value: "functions_involved",
        align: "start",
        width: "100px",
      },
      {
        text: "Start Timestamp",
        value: "start_timestamp",
        align: "start",
        width: "100",
      },
    ],
    apiLogs: [],
    Servicesarray: [],
    Endpointarray: [],
    loaderOverlay: false,
    search: "",
    from_date: null,
    to_date: null,
    service: null,
    record_id: null,
    end_point: null,
  }),
  computed: {
    maxDate() {
      // get current date and format as YYYY-MM-DD for use with max attribute
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const day = now.getDate();
      return `${year}-${month.toString().padStart(2, "0")}-${day
        .toString()
        .padStart(2, "0")}`;
    },
  },
  mounted() {
    // this.getApilogdata()
    this.getserviceValues();
  },
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    downloadTxtFile(data) {
      this.downloadFile(data);
    },
    validateFromDate(value) {
      if (value && this.to_date) {
        return (
          value <= this.to_date || "From date cannot be later than To date"
        );
      }
      return true;
    },
    validateToDate(value) {
      if (value && this.from_date) {
        return (
          value >= this.from_date || "To date cannot be earlier than From date"
        );
      }
      return true;
    },
    async getserviceValues() {
      try {
        const responseData = await commonService.getserviceValues("ALOG");
        if (responseData.data.status_code === 200) {
          this.Servicesarray = responseData.data.data.map((i) => {
            return { name: i.value, id: i.value_code };
          });
        }

        console.log("getserviceValues", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getEndpointValues() {
      console.log("this.service", this.service);
      try {
        const responseData = await commonService.getEndpointValues(
          this.service
        );
        if (responseData.data.status_code === 200) {
          this.Endpointarray = responseData.data.data.map((i) => {
            return { name: i.value, id: i.value_code };
          });
        }

        console.log("getEndpointValues", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getApilogdata() {
      const validate = this.$refs.logs.validate();
      if (validate) {
        this.loaderOverlay = true;
        try {
          const params = {
            from_date: this.from_date,
            to_date: this.to_date,
            service: this.service,
            endpoint: this.end_point,
            record_id: this.record_id,
            skip: 0,
            limit: 50,
          };
          const response = await commonService.getApilog(params);
          if (response.status === 200) {
            this.apiLogs = response.data.data;
            console.log("apiLogs", this.apiLogs);
            this.stoploader();
          } else {
            this.apiLogs == [];
            this.stoploader();
          }
        } catch (error) {
          this.apiLogs = [];
          this.stoploader();
          console.error(error);
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/global.scss";
</style>
